import { getOrderDetailsByLoanId } from '@nemuru-eng/js-api-client';

import { useCache } from '@/hooks/requests/useCache';

export const useShippingAndBillingDetails = ({ loanId }: { loanId: string }) => {
  const { data: orderDetails, loading } = useCache(getOrderDetailsByLoanId, { loanId });

  const shipping = orderDetails?.shipping ?? null;
  const billing = orderDetails?.billing ?? null;

  const patchOrderDetails = (data) => {
    //TODO ==> missing async patchLoanDetails request here
    console.log('TODO => PATCH ORDER DETAILS', { data });
  };

  return {
    shipping,
    billing,
    patchOrderDetails,
    loading,
  };
};
